import React from 'react';

export const Logo = ({ size = 20, withWord = true }) => (
  <div className="flex items-center gap-2" data-testid="app-logo">
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="2" y="2" width="20" height="20" rx="5" fill="hsl(var(--primary))" />
      <path d="M7 8.5L12 6l5 2.5v7L12 18l-5-2.5v-7z" stroke="hsl(var(--primary-foreground))" strokeWidth="1.6" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="1.6" fill="hsl(var(--primary-foreground))" />
    </svg>
    {withWord && <span className="text-sm font-semibold tracking-tight">Redserp</span>}
  </div>
);
